import React, { useState, useEffect } from 'react'
import { List } from '../../blog/components'
import { ArrayChecker, SearchInput } from '../../../components'
import { useSelector } from 'react-redux'

const ListBlog = () => {
  const [keyword, setKeyword] = useState('')
  const [mainData, setMainData] = useState([])
  const [data, setData] = useState([])
  const { isIndividu } = useSelector(state => state.account)
  const individuData = useSelector(state => state.individu.data_bookmark.blogs)
  const defaultData = useSelector(state => state.blogs.data)
  const { language } = useSelector(state => state.system)

  useEffect(() => {
    if(isIndividu && individuData){
      setMainData(individuData)
      setData(individuData)
    } else {
      setMainData(defaultData)
      setData(defaultData)
    }
  }, [individuData, isIndividu, defaultData])

  const handleSubmit = () => {
    if(!keyword || keyword === ''){
      setData(mainData)
    } else {
      setData(mainData.filter(d => d.title[language.name]?.toLowerCase().includes(keyword.toLowerCase())))
    }
  }

  const handleChange = (e) => {
    if(e && e.target){
      setKeyword(e.target.value)
    }
  }

  return (
    <div>
      <div className="w-full xl:w-6/12 mb-5 lg:mb-10">
        <SearchInput onChange={handleChange} onSearchSubmit={handleSubmit} />
      </div>
      <ArrayChecker data={data}>
        <List data={data} bookmark={true} uniform/>
      </ArrayChecker>
    </div>
  )
}

export { ListBlog }
